


import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import AllBookedAppointments from "./AllBookedAppointments";
import AppointmentDetails from "../../ProviderComponents/AppointmentDetails/AppointmentDetails";



const AllAppointmentTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Appointments", component: "allAppointments" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (appointment) => {
    const existingTab = tabs.find((tab) => tab.id === appointment.pc_eid);
    if (!existingTab) {
      setTabs([...tabs, { id: appointment.pc_eid, label: appointment.pc_eid, component: "appointmentDetails", data: appointment }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === appointment.pc_eid));
    }
  };

  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
  
    setTabs(newTabs);
  
    // Ensure selectedTab is always within range
    setSelectedTab((prevIndex) => Math.min(prevIndex, newTabs.length - 1));
  };
  
  
  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 0 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allAppointments" && <AllBookedAppointments onAppointmentsClick={handleAddTab} />}
        {tabs[selectedTab].component === "appointmentDetails" && <AppointmentDetails appointmentData={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default AllAppointmentTabs;
